/** Shared shape for any `{ value, label }` enum entry served by the API. */
export type LabeledValuePayload = {
	readonly value: string;
	readonly label: string;
};

export type UserStatusesFetchedPayload = LabeledValuePayload[];

export type UserStatusesFetchedAction = {
	type: 'USER_STATUSES_FETCHED';
	payload: UserStatusesFetchedPayload;
};

export default (payload: UserStatusesFetchedPayload): UserStatusesFetchedAction => ({
	type: 'USER_STATUSES_FETCHED',
	payload,
});
